module.exports = __webpack_public_path__ + "static/media/refer-a-host-page-desktop.4e097325.png";